// extracted by mini-css-extract-plugin
export default {"summaryRow":"access-summary-row_summaryRow__GUg+n"};